import {ComponentTypes} from "../types";
import {three as threeTypes} from "../../../types";
import {createGumball} from "../gumball";
import {Param_Mesh, Param_Number, ParamTitles, ParamValueTypes} from "../../parameter";
import {MeshResolution} from "../../const";
import {Calc} from "../../calc";
import {WompMesh} from "../../../WompObject";
import {getMeshDataFromThreeGeometry} from "../../../converter";
import {mat4, vec3} from "gl-matrix";
import {BasicMeshGenerator} from "./basic-gen";

export class ThreeDonutGenerator extends BasicMeshGenerator {
  static defaultParameter = {
    radius: 20,
    innerRadiusPercent: 50
  };
  static draggingPreview = ThreeDonutGenerator.generateMesh();

  static create() {
    let calc = createGumball();
    calc.component = ComponentTypes.ThreeDonutGenerator;
    calc.title = 'donut';

    let innerRadiusParam = Param_Number.create(calc, ParamTitles.InnerRadius, true, true, {
      type: ParamValueTypes.Percent,
      defaultValue: this.defaultParameter.innerRadiusPercent
    });
    let donutParam = Param_Mesh.create(calc, ParamTitles.Donut, false, false, true);

    calc.addParameter(innerRadiusParam);
    calc.addParameter(donutParam);

    return calc;
  }

  static getDesc(calc: Calc) {
    let innerRadiusParam = calc.inputByTitle(ParamTitles.InnerRadius) as Param_Number;
    let innerRadiusPercent = innerRadiusParam.values[0] || this.defaultParameter.innerRadiusPercent;

    return `donut[${innerRadiusPercent.toFixed(4)}]`;
  }

  static getParameter(calc: Calc) {
    let innerRadiusParam = calc.inputByTitle(ParamTitles.InnerRadius) as Param_Number;
    let innerRadiusPercent = innerRadiusParam.values[0] || this.defaultParameter.innerRadiusPercent;

    return {...this.defaultParameter, innerRadiusPercent};
  }

  static generateMesh(parameter: any = this.defaultParameter) {
    let value: threeTypes.BufferGeometry = new threeTypes.TorusBufferGeometry(
      this.defaultParameter.radius,
      parameter.innerRadiusPercent * this.defaultParameter.radius / 100,
      Math.round(MeshResolution / 1.5),
      Math.round(MeshResolution / 1.5)
    );

    let geom = getMeshDataFromThreeGeometry(value);

    return new WompMesh(geom, this.generateMatrix(parameter));
  }

  static generateMatrix(parameter: any = this.defaultParameter) {
    return mat4.fromScaling(
      mat4.create(),
      vec3.fromValues(
        parameter.radius / this.defaultParameter.radius,
        parameter.radius / this.defaultParameter.radius,
        parameter.radius / this.defaultParameter.radius
      )
    );
  }
}